import queryString from 'query-string';

export const getTokens = () => {
	const { token } = JSON.parse(localStorage.getItem('token') || '{}');
	const { adminToken } = JSON.parse(localStorage.getItem('adminToken') || '{}');

	return { token, adminToken };
}


const getJWTToken = () => {
	const searchUrlObj = queryString.parse(window.location.search);
	return searchUrlObj.token;
}

export const getTokenWithAuthCheck = () => {
	const { token } = getTokens(); // токен, полученный при авторизации
	const jwtToken = getJWTToken(); // токен из ссылки
	let userToken = token;

	// если пользователь незалогинен и у него нет токена авторизации,
	// но есть jwt токен из ссылки, используем его
	if (!token && jwtToken && typeof jwtToken === 'string') {
		userToken = jwtToken;
	}

	return userToken;
}
